export const getPayloadData = (cardNumber: string | undefined, userId: string | undefined, accountType: string) => {
	if (cardNumber) {
		return {
			account: accountType,
			cr_card_number: cardNumber.slice(0, 19)
		};
	}
	if (userId) {
		return {
			account: accountType,
			member_id: userId
		};
	}
};
